
import { Vue, Component } from 'vue-property-decorator'
import CreateClueDialog from '../../components/clueRecommend/createDialog.vue'
import { ClueService } from '@/services'

@Component({
    components: {
        CreateClueDialog
    }
})
export default class ClueRecommend extends Vue {
    private isLoading = false
    private loadingMsg = '加载中'
    private clueList = []
    private curClue = {}
    /* ---------------------- 分界线 ---------------------- */
    get createDialog() {
        return this.$refs.createDialog as any
    }
    private onCreate() {
        this.createDialog.show()
    }
    private async onCreateClue(clue: any) {
        const params = {
            order: +clue.order,
            title: clue.title,
            cover_img: clue.img,
            published_at: clue.publish,
            url: clue.url
        }
        const result = await ClueService.createClueRecommend(params)
        this.createDialog.hide()
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '创建线索成功',
                showClose: true
            })
            this.getClueRecommedList()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误，创建失败',
            showClose: true
        })
    }
    private mounted() {
        this.getClueRecommedList()
    }
    // 获取推荐线索列表
    private async getClueRecommedList() {
        const params = {}
        const result = await ClueService.getClueRecommendList(params)
        if (result.status === 200) {
            this.clueList = result.data
        }
    }

    // 编辑线索
    private async onEditClue(cid: number) {
        const { href } = this.$router.resolve({
            name: 'ClueRecommendDetail',
            params: { id: String(cid) }
        })
        window.open(href, '_blank')
    }

    // 删除推荐线索
    private async onDeleteClue(id: number) {
        const params = { id }
        const result = await ClueService.deleteClueRecommend(params)
        if (result.status === 200) {
            this.getClueRecommedList()
            return this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
        }
        return this.$message({
            type: 'error',
            message: result.message || '发生错误，删除失败',
            showClose: true
        })
    }

}
